"use client"

import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import colors from "@/lib/theme/colors"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import Link from "next/link"
import CustomBreadcrumbs from "../shared/CustomBreadcrumbs"
import ImageContainer from "../shared/ImageContainer"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 48px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 64px;
  }
`

const BreadcrumbsWrapper = styled.div`
  max-width: 1070px;
  width: 100%;
  margin: auto;
  padding: 0 16px;
`

const InnerLayout = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 810px;
  width: 100%;

  margin: auto;
  gap: 12px;
  padding: 0 16px 80px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 8px;
    align-items: center;
    padding: 24px 16px 10px;
  }
`

const ContactBoxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    padding-top: 16px;
    gap: 16px;
  }
`

const ContactBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;

  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 240px;
    padding: 16px;
    gap: 16px;
    flex-direction: column;
  }
  border: 1px solid ${colors.directVeryLightGray};
  background: white;
`

const StyledLink = styled(Link)`
  font-size: 18px;
  color: black;
  font-weight: 400;
  line-height: normal;
`

function Profile(): React.ReactElement {
  return (
    <StyledLayout>
      <ImageContainer
        desktopUrl="/images/profiledesktop.png"
        mobileUrl="/images/profilemobile.png"
        height={345}
        mobileHeight={220}
      />
      <BreadcrumbsWrapper>
        <CustomBreadcrumbs
          current={{ title: "צור קשר", url: "/profile" }}
          parents={[{ title: "ראשי", url: "/" }]}
        />
      </BreadcrumbsWrapper>
      <InnerLayout>
        <Desktop>
          <Typography variant="h2">צרו קשר</Typography>
        </Desktop>
        <Mobile>
          <Typography variant="h3">צרו קשר</Typography>
        </Mobile>
        <Desktop>
          <Typography variant="subtitle1" fontWeight={400}>
            דלק מוטורס בע״מ
          </Typography>
        </Desktop>
        <Mobile>
          <Typography variant="body1" fontWeight={400}>
            דלק מוטורס בע״מ
          </Typography>
        </Mobile>
        <Desktop>
          <Typography variant="subtitle1" fontWeight={400}>
            אזור תעשייה ניר צבי, ת.ד. 200, 7290500
          </Typography>
        </Desktop>
        <Mobile>
          <Typography variant="body1" fontWeight={400}>
            אזור תעשייה ניר צבי, ת.ד. 200, 7290500
          </Typography>
        </Mobile>
        <ContactBoxes>
          <ContactBox>
            <Desktop>
              <Image src="/assets/call-calling.svg" alt="phone" width={40} height={40} />
            </Desktop>
            <Mobile>
              <Image src="/assets/call-calling.svg" alt="phone" width={20} height={20} />
            </Mobile>
            <StyledLink href="tel:08-9139995">08-9139995</StyledLink>
          </ContactBox>
          <ContactBox>
            <Desktop>
              <Image src="/assets/sms-tracking.svg" alt="phone" width={40} height={40} />
            </Desktop>
            <Mobile>
              <Image src="/assets/sms-tracking.svg" alt="phone" width={20} height={20} />
            </Mobile>
            <StyledLink href={`mailto:service1@delekmotors.co.il`}>
              service1@delekmotors.co.il
            </StyledLink>
          </ContactBox>
        </ContactBoxes>
      </InnerLayout>
    </StyledLayout>
  )
}

export default Profile
